import { endpoints } from 'modules/endpoints'
import { createBasicManagers } from 'modules/utils/helpers/createBasicManagers'
import { octopusApiClient } from 'modules/utils/httpClient'
import { ListResponse } from 'types/api'
import {
  TargetSkuListRequestFilter,
  TargetSkuListRequestSorting,
  RetailerTargetSku,
  RetailerTargetSkuCreateDTO,
  TargetSkuUpdateDTO,
} from '../common/types'

// export default createBasicManagers<
//   TargetSkuListRequestFilter,
//   TargetSkuListRequestSorting,
//   RetailerTargetSku,
//   RetailerTargetSkuCreateDTO,
//   TargetSkuUpdateDTO
// >(endpoints.retailerTargetSku, octopusApiClient)

const retailerTargetSkuManagers = {
  ...createBasicManagers<
    TargetSkuListRequestFilter,
    TargetSkuListRequestSorting,
    RetailerTargetSku,
    RetailerTargetSkuCreateDTO,
    TargetSkuUpdateDTO
  >(endpoints.retailerTargetSku, octopusApiClient),
  getList: (
    filter: TargetSkuListRequestFilter,
    sorting: TargetSkuListRequestSorting,
    page: number,
    pageSize?: number,
  ) => {
    try {
      return octopusApiClient.get<ListResponse<RetailerTargetSku>>(endpoints.retailerTargetSku(), {
        ...filter,
        ...sorting,
        page: page,
        page_size: pageSize,
        order_by: 'retailer_asc',
      })
    } catch (err) {
      console.error('List fetch error!', err)
      throw err
    }
  },
}

export default retailerTargetSkuManagers
